import Swiper, { Pagination, Navigation } from 'swiper';
import { ProductMedia } from "Modules/productMedia";
Swiper.use([Pagination, Navigation]);

// @ts-ignore
let module: any = {};
module.setupScrollHelper = () => {
	window.addEventListener('scroll', () => {
		$('.tooltipster-base').hide();
	});
}

module.askQuestion = () => {
	function eventFire(el: HTMLElement, etype: string) {
		const evObj = new Event(etype, {
			bubbles: true,
			cancelable: false,
		});
		el.dispatchEvent(evObj);
	}

	document.body.addEventListener('click', (event: Event) => {
		const target = event.target as HTMLElement;
		if (target.classList.contains('bv_war_button')) {
			event.preventDefault();
			const reviewsTab = document.querySelector('.js-tab[data-target="#reviews"]') as HTMLElement | null;
			if (reviewsTab) {
				eventFire(reviewsTab, 'click');
				const topPosition = reviewsTab.getBoundingClientRect().top + window.scrollY;
				window.scrollTo({
					top: topPosition,
					behavior: 'smooth',
				});
			}
		}
	});

	document.body.addEventListener('click', (event: Event) => {
		const target = event.target as HTMLElement;
		if (target.classList.contains('bv_aaq_button')) {
			event.preventDefault();
			const qasTab = document.querySelector('.js-tab[data-target="#qas"]') as HTMLElement | null;
			if (qasTab) {
				eventFire(qasTab, 'click');
				const topPosition = qasTab.getBoundingClientRect().top + window.scrollY;
				window.scrollTo({
					top: topPosition,
					behavior: 'smooth',
				});
			}
		}
	});
};

module.printInit = () => {
	let printBtn = document.querySelector('.js-window-print');
	printBtn.addEventListener('click', () => {
		window.print();
	});
}

module.init = function () {
	module.askQuestion();
	module.printInit();
	module.setupScrollHelper();
	ProductMedia.init();
};



if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', module.init);
} else {  // `DOMContentLoaded` has already fired
	module.init();
}
